<div *ngIf="isSubmitted; else feedbackSurvey">
  <p class="survey__confirmation typog-caption-regular mb-2">
    <dgx-components-icon
      [family]="'light'"
      [icon]="'thumbs-up'"
      [size]="'sm'"
      class="light-survey-icon"
    />
    <strong>Thanks for your feedback</strong>
  </p>
  <p>
    You can find more helpful content on our
    <a [href]="confirmationLink">Smart-fix Hub</a>
  </p>
</div>
<ng-template #feedbackSurvey>
  <p
    *ngIf="feedbackQuestion"
    class="survey__question typog-caption-regular mb-3"
  >
    <strong>{{ feedbackQuestion }}</strong>
  </p>
  <div class="survey__button-wrapper" [ngClass]="{ error: isError }">
    <div
      *ngFor="let option of votingOptions"
      class="survey__button"
      (click)="onVote(option)"
      (keydown.enter)="onVote(option)"
      tabindex="0"
      [ngClass]="{ selected: option === selectedOption }"
    >
      <div class="button-container">
        <div class="survey__button-fake-radio"></div>
        <dgx-components-icon
          [family]="'light'"
          [icon]="option.icon"
          [size]="'sm'"
          class="light-survey-icon"
        />
        <p class="survey__button-description typog-caption-regular">
          {{ option.label }}
        </p>
      </div>
    </div>
    <p class="error-message mobile">
      <dgx-components-icon
        [family]="'light'"
        [icon]="'exclamation-circle'"
        [size]="'sm'"
      />Choose an option
    </p>
    <dgx-components-button
      (clicked)="onClick()"
      [disabled]="false"
      [type]="button"
      [variant]="'secondary'"
      class="submit-button"
      (keydown.enter)="onClick()"
    >
      Send your feedback
    </dgx-components-button>
    <p class="error-message desktop">
      <dgx-components-icon
        [family]="'light'"
        [icon]="'exclamation-circle'"
        [size]="'sm'"
      />Choose an option
    </p>
  </div>
</ng-template>
